import { render, staticRenderFns } from "./KimmuJisseki.vue?vue&type=template&id=5e85e1de&scoped=true"
import script from "./KimmuJisseki.vue?vue&type=script&lang=js"
export * from "./KimmuJisseki.vue?vue&type=script&lang=js"
import style0 from "./KimmuJisseki.vue?vue&type=style&index=0&id=5e85e1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e85e1de",
  null
  
)

export default component.exports